import { useCallback, type MouseEvent } from "react";
import { useAppStore } from "../../../state/app-store";

export function useEditorSafeAnchorClick() {
  const isEditor = useAppStore((state) => state.runtimeMode === "editor");

  const handleAnchorClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      if (!isEditor) return;
      event.preventDefault();
      event.stopPropagation();
    },
    [isEditor]
  );

  return { isEditor, handleAnchorClick };
}
